<nav class="m-menu"
     :class="[ 'm--is-skin-' + skin,
               { 'm--is-open': propOpen,
                 'm--is-disabled': propDisabled }]">
    <div v-if="$slots.trigger"
         :id="id"
         class="m-menu__trigger"
         :class="{'m--is-disabled': propDisabled }"
         ref="buttonMenu"
         role="button"
         :tabindex="propDisabled ? '-1' : '0'"
         :aria-controls="idAriaControls"
         :aria-expanded="propOpen ? 'true' : 'false'"
         @click="toggleMenu"
         @keydown.enter="toggleMenu"
         @keydown.space="toggleMenu">

        <m-plus class="m-menu__trigger__plus"
                :large="true"
                :open="propOpen"
                skin="current-color"></m-plus>
        <slot name="trigger"></slot>
    </div>
    <m-accordion-transition ref="transition"
                            @before-enter="beforeEnter"
                            @enter="enter"
                            @after-enter="afterEnter"
                            @enter-cancelled="enterCancelled"
                            @before-leave="beforeLeave"
                            @leave="leave"
                            @after-leave="afterLeave"
                            @leave-cancelled="leaveCancelled"
                            :disabled="!animReady || propDisabled">
        <ul v-show="propOpen"
            :id="idAriaControls"
            ref="menu"
            class="m-menu__body"
            :aria-labelledby="id">
            <slot></slot>
        </ul>
    </m-accordion-transition>
</nav>
